<template lang="html">
  <section class="experience-section-component">
    <div class="container">
      <div class="box-content">
        <!-- <h2 class="text-center title-2">Nosotros</h2> -->

        <!-- <p class="p-md text-center">
          xx
        </p> -->

        <div class="row row-info">
          <div class="col-lg-5 col-xl-5 col-image pr-lg-5">
            <img src="public/images/logo-white.svg">
          </div>

          <div class="col-lg-7 col-info">
            <p>
              En BlackFon creemos que la conectividad no debería tener fronteras.<br />
              Nacimos con una misión muy clara: ofrecer una nueva forma de comunicación móvil, con un servicio exclusivo, confiable y diseñado para quienes necesitan estar conectados en México, Estados Unidos y Canadá.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
}
</script>
